import { capabilities } from "../data/products";

export const Marquee = () => {
  const items = [...capabilities, ...capabilities];
  return (
    <div
      data-testid="capability-marquee"
      className="marquee-mask select-none overflow-hidden border-y border-hairline bg-surface py-6"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {items.map((c, i) => (
          <span key={i} className="flex items-center">
            <span className="px-8 text-[15px] font-medium text-slatetx">
              {c}
            </span>
            <span className="text-platinum" aria-hidden>
              ·
            </span>
          </span>
        ))}
      </div>
    </div>
  );
};
